const url = "http://admin.zun1.com/"
export default{
    url
}
export function findElem(arrayToSearch,attr,val) {
    for(var i = 0;i<arrayToSearch.length;i++){
        if(arrayToSearch[i][attr] == val){
            return true;
        }
    }
    return false;
  }



// WEBPACK FOOTER //
// ./src/config/url.js